export default "__VITE_ASSET__614548a6__"